export default {"src":"/_next/static/media/about2.cc061da7.svg","height":226,"width":261};